import { render, staticRenderFns } from "./TableDefault.vue?vue&type=template&id=6aa1bb7f&scoped=true"
import script from "./TableDefault.vue?vue&type=script&lang=js"
export * from "./TableDefault.vue?vue&type=script&lang=js"
import style0 from "./TableDefault.vue?vue&type=style&index=0&id=6aa1bb7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa1bb7f",
  null
  
)

export default component.exports